<template>
	<div class="c-log">
		<p v-if="$slots.default" class="c-log-info"><slot></slot></p>
		<p v-else class="c-log-info">{{date}} 由 <span>{{person}}</span> {{action}} <slot name="tag"></slot></p>
		<div v-if="$slots.remark || $slots.image" class="c-log-content">
			<div v-if="$slots.remark" class="c-log-remark"><slot name="remark"></slot></div>
			<div v-if="$slots.image" class="c-log-image flex-wrap"><slot name="image"></slot></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'logItem',

		props: {
			date: String,
			person: String,
			action: String
		}
	}
</script>

<style lang="stylus" scoped>
	.c-log {
		padding: .1rem 0;

		&-info {
			margin: 0 .18rem;
			line-height: .4rem;
			font-size: .28rem;
			color: #666;

			span {
				color: var(--color-main);
			}
		}

		&-content {
			border-radius: .04rem;
			padding: .14rem .24rem;
			margin-top: .1rem;
			background: #F9F9F9;
		}

		&-remark {
			overflow: hidden;

			>>> .c-field {
				font-size: .26rem;
				color: #666;
			}

			+ .log-image {
				margin-top: .1rem;
			}
		}

		&-image {
			gap: .24rem;
			margin-top: .1rem;
			
			>>> .c-file-media {
				width: 1.6rem;
				height: 1.6rem;
				border: none;
			}
		}
	}
</style>
